export default __webpack_public_path__ + "static/media/figma.b35704e9.svg";